import axios from 'axios';
import { BRAZILIAN_STATES } from 'app/components/OnBoardingModals/constants';
import { invalidateOabEligibility } from 'app/services/oabEligibility/invalidateOabEligibility';
import {
  OabConfirmationSurface,
  trackOabConfirmed,
} from './trackOabConfirmedEvent';

const baseAPI = process.env.REACT_APP_API_URL;
const NOT_FOUND = 404;

export interface OabPendingResponse {
  id: number;
  clientId: number;
  oabNumber: string;
  lawyerName: string;
  status: 'pending_confirm';
}

export type PendingOab = {
  id: number;
  uf: string;
  oabNumber: string;
};

const UF_THEN_DIGITS = new RegExp(
  `^(${BRAZILIAN_STATES.map(({ state }) => state).join('|')})(\\d+)$`,
);

export function parsePendingOab(
  pending: OabPendingResponse | null | undefined,
): PendingOab | null {
  const match = pending?.oabNumber?.match(UF_THEN_DIGITS);

  if (!pending || !match) {
    return null;
  }

  const [, uf, oabNumber] = match;

  return { id: pending.id, uf, oabNumber };
}

export const getOabPending = (): Promise<OabPendingResponse | null> => {
  return axios
    .get(`${baseAPI}/monitoring/v2/oab/pending`)
    .then((response) => response.data)
    .catch((error) => {
      if (error?.response?.status === NOT_FOUND) {
        return null;
      }
      throw error;
    });
};

export const confirmOab = (
  oabMonitoringId: number,
  oabNumber: string,
  surface: OabConfirmationSurface,
): Promise<unknown> => {
  return axios
    .put(`${baseAPI}/monitoring/v2/oab/confirm/oab/${oabMonitoringId}`, {
      oabNumber,
    })
    .then((response) => {
      invalidateOabEligibility();
      trackOabConfirmed('pending', surface);
      return response.data;
    });
};
